import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import pxToRem from 'assets/theme/function/px-to-rem';
import { initialListData } from 'pages/cards-sphere/index';
import { CardsSphereListRequest } from 'types/card/card-sphere-list';
import { useStatusListQuery } from 'store/slices/user/user';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    setDataSphereRequestList?: React.Dispatch<
        React.SetStateAction<CardsSphereListRequest>
    >;
}

const FilterCardSphere: React.FC<Props> = (props: Props) => {
    const { setDataSphereRequestList } = props;
    const { handleSubmit, control, reset } = useForm<CardsSphereListRequest>();
    const { data: statusList } = useStatusListQuery();

    const onSubmit = (values: CardsSphereListRequest) => {
        if (setDataSphereRequestList) {
            setDataSphereRequestList((prevState) => ({
                ...prevState,
                title: values.title,
                code: values.code,
                status: values.status,
            }));
        }
    };

    const resets = () => {
        reset();
        if (setDataSphereRequestList) {
            setDataSphereRequestList(initialListData);
        }
    };
    return (
        <Box
            pt={pxToRem(10)}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            component="form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <Box display={'flex'} flexBasis={'100%'}>
                <Controller
                    name="title"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Title'}
                            name={name}
                            value={value || ''}
                            sx={{ width: '30%' }}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                        />
                    )}
                />

                <Controller
                    name="code"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Code'}
                            name={name}
                            value={value || ''}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                            sx={{ ml: pxToRem(10), width: '30%' }}
                        />
                    )}
                />

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Product Status</InputLabel>
                    <Controller
                        name="status"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Product Status"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Product Status"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {statusList?.map((status) => (
                                    <MenuItem
                                        key={status.toString()}
                                        value={status.toString()}
                                    >
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
            </Box>

            <Box display={'flex'} alignItems={'center'} ml={pxToRem(20)}>
                <Button
                    fullWidth
                    sx={{ mr: pxToRem(20), px: pxToRem(20) }}
                    variant={'contained'}
                    type={'submit'}
                >
                    Search
                </Button>
                <Button
                    fullWidth
                    sx={{ px: pxToRem(20) }}
                    variant={'contained'}
                    color={'secondary'}
                    onClick={resets}
                >
                    Clear
                </Button>
            </Box>
        </Box>
    );
};

export default FilterCardSphere;
